import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useCoddingManualInsert = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [failed, setFailed] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const saveManual = (
    { originGuid, branchGuid, profileGuid, title, code, titleRequired },
    cb,
  ) => {
    setLoading(true);

    axiosClient
      .post(`Product/Branch/Codding/Manual/Insert`, {
        profileGuid,
        originGuid,
        branchGuid,
        title,
        code,
        titleRequired,
      })
      .then(res => {
        if (res.status === 200) {
          setData(res.data.value);
          setFailed(false);
          if (cb) {
            cb(res.data.value);
          }
        } else {
          enqueueSnackbar(res.data?.message, { variant: 'error' });
          setFailed(true);
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
        setFailed(true);
      })
      .finally(() => setLoading(false));
  };

  return [saveManual, loading, data, failed];
};

export default useCoddingManualInsert;
